module.exports = __webpack_public_path__ + "static/img/xxpp.2a7eea2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xxpp.png
// module id = OgKJ
// module chunks = 0